<template>
  <div>頁面跳轉中...</div>
</template>
<script>
export default {
  created() {
    this.initAuthenticationCode();
  },
  methods: {
    async initAuthenticationCode() {
      try {
        const { data } = await this.$http(
          'get',
          `t/teams/authentication/${this.$route.query.code}`,
          {},
          false
        );
        const i18n = this.$route.query.i18n;
        if (data) {
          let url = `${location.origin}?teamId=${data.id}`;
          if (i18n) {
            url += `&i18n=${i18n}`;
          }
          location.replace(url);
        } else {
          let url = location.origin;
          if (i18n) {
            url += `?i18n=${i18n}`;
          }
          location.replace(url);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
